<template>
<v-flex xs12 class="mx-auto">
  <v-img v-if="!sliderVisible"
    aspect-ratio="3"
    cover
    lazy-src="@/assets/img/back-nobanner.jpg"
    src="@/assets/img/back-nobanner.jpg"
  >
  </v-img>
  <carousel v-else
  :per-page="1" autoplay loop
  :mouse-drag="false"
   centerMode
   :autoplayTimeout="3000"
   paginationPosition="bottom"
   class="container-item-banner"
   :paginationPadding="3"
   :paginationSize="15"
   >
    <slide v-for="(item , idx) in itemsBanner"
    :key="'banner-'+idx">
    <v-img
      aspect-ratio="3"
      cover
      :src="item.imagenes_api[0]"
      >
      <template v-slot:placeholder>
        <v-row
          class="fill-height ma-0"
          align="center"
          justify="center"
        >
          <v-progress-circular
            indeterminate
            color="grey lighten-5"
          ></v-progress-circular>
        </v-row>
      </template>
      </v-img>
    </slide>
  </carousel>
</v-flex>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      sliderVisible: false,
      itemsBanner: []
    }
  },
  async mounted () {
    await axios
      .get('' + this.$store.state.rutaApi + 'elementos_banner')
      .then(response => (this.itemsBanner = response.data))
    this.sliderVisible = true
  }
}
</script>
<style lang="scss">

.container-item-banner{
  overflow: hidden;
}
.VueCarousel-pagination{
  margin-top: -33px;
  z-index: 0;
}

</style>
